import TRANSLATION_ACCESSIBILITY_ZH_HANT from './accessibility/translation';
import TRANSLATION_BOOKING_ZH_HANT from './booking/translation';
import TRANSLATION_EVENTS_ZH_HANT from './events/translation';
import TRANSLATION_EXPERIENCES_ZH_HANT from './experiences/translation';
import TRANSLATION_FORM_ZH_HANT from './form/translation';
import TRANSLATION_LANDING_PAGES_ZH_HANT from './landingPages/translation';
import TRANSLATION_RESERVE_ZH_HANT from './reserve/translation';
import TRANSLATION_SIGNIN_ZH_HANT from './signin/translation';
import TRANSLATION_DATES_ZH_HANT from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_ZH_HANT,
  ...TRANSLATION_BOOKING_ZH_HANT,
  ...TRANSLATION_EVENTS_ZH_HANT,
  ...TRANSLATION_EXPERIENCES_ZH_HANT,
  ...TRANSLATION_FORM_ZH_HANT,
  ...TRANSLATION_LANDING_PAGES_ZH_HANT,
  ...TRANSLATION_RESERVE_ZH_HANT,
  ...TRANSLATION_SIGNIN_ZH_HANT,
  ...TRANSLATION_DATES_ZH_HANT,
};
